var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-cloudy",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32,14.72c-2.474,0-4.479-2.005-4.479-4.479 c0-2.474,2.005-4.479,4.479-4.479c1.681,0,3.144,0.927,3.911,2.297c0.186-0.032,0.374-0.058,0.568-0.058 c1.855,0,3.36,1.504,3.36,3.359s-1.505,3.359-3.36,3.359C10.022,14.72,7.215,14.72,6.32,14.72z M10.799,13.6 c1.237,0,2.24-1.003,2.24-2.239c0-1.237-1.003-2.24-2.24-2.24c-0.447,0-0.862,0.136-1.213,0.362 C9.241,7.993,7.913,6.881,6.32,6.881c-1.855,0-3.359,1.504-3.359,3.359S4.465,13.6,6.32,13.6C7.332,13.6,9.954,13.6,10.799,13.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.dd9b2a8b51511368ff0de487446e5c95.svg";
export { ForwardRef as ReactComponent };